import React from 'react';

/**
 * BreathingFlameMark — official Enferno flame PNG (V4.6 / V6.1) with a subtle
 * "breathing" animation. Default src is the V4.6 mark; callers override for
 * legacy surfaces if needed.
 *
 * Props:
 *   size  — px (square), default 200
 *   intensity — 'subtle' | 'normal' | 'lively' — animation amplitude
 */
const BreathingFlameMark = ({ size = 200, intensity = 'normal', className = '', alt = 'Enferno', src = '/brand/enferno-flame-mark-v46.png' }) => {
  const intensityClass = `enferno-breathe-${intensity}`;
  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      {/* Warm halo glow that breathes in sync */}
      <div
        className={`absolute inset-0 rounded-full enferno-breathe-halo ${intensityClass}`}
        style={{
          background:
            'radial-gradient(circle, rgba(249,115,22,0.35) 0%, rgba(220,38,38,0.18) 40%, rgba(155,28,31,0.05) 75%, transparent 100%)',
          filter: 'blur(16px)',
        }}
      />
      {/* The actual mark — caller can override for surface-specific variants */}
      <img
        src={src}
        alt={alt}
        className={`relative z-10 enferno-breathe-mark ${intensityClass}`}
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />
    </div>
  );
};

export default BreathingFlameMark;
